import Box from '@material-ui/core/Box';

import type { PlainGeofence } from '@cobliteam/common-types/src/geofenceV3';

import { Checkbox } from '@cobliteam/base-components/src/SelectionControls/Checkbox';

interface GeofenceItemProps {
  checked: boolean;
  geofence: PlainGeofence;
  onChange: () => void;
}

const GeofenceItem = ({ checked, onChange, geofence }: GeofenceItemProps) => {
  const { id, name } = geofence;
  return (
    <Box margin='0 20px'>
      <Checkbox
        key={`${id}-${geofence}`}
        ellipsis
        title={name}
        checked={checked}
        onChange={onChange}
        label={name}
      />
    </Box>
  );
};
export default GeofenceItem;
